import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { ReferralCustomTargetUrl } from '@pages/IntroducingBroker/Dashboard/ReferralLink/ReferralCustomTargetUrl'
import { ReferralLinkUrlFields } from '@pages/IntroducingBroker/LinkHub/Links/components/ReferralLinkUrlFields'
import { SectionHeader } from '@pages/IntroducingBroker/LinkHub/Links/components/SectionHeader'
import { getLandingPageUrl, getLinkStyles } from '@pages/IntroducingBroker/LinkHub/Links/helpers'
import { useLinkHub } from '@pages/IntroducingBroker/LinkHub/Links/hooks/useLinkHub'
import { LinkProps } from '@pages/IntroducingBroker/LinkHub/Links/types'

import { useWindowResize } from '@utils/domUtils'

import { IntroducingBrokerReferralTypes } from '@model/IntroducingBrokerDetailsDto'

import { Box } from '@shared/components/Box'

export const CustomTargetLink = ({
  ibCode,
  mtCode,
  ibLink,
  mtLink,
  fetchShortenedIBLink,
}: LinkProps) => {
  const { links, shortening, landingPages } = useLinkHub({
    ibCode,
    mtCode,
    ibLink,
    mtLink,
    fetchShortenedIBLink,
    isCustomType: true,
  })

  const { mainReferralLink, mtReferralLink } = links
  const {
    shortenedMainReferralLink,
    shortenedMTReferralLink,
    isShortMainLinkLoading,
    isShortMTLinkLoading,
    isShorteningAvailable,
    handleIBLinkShortening,
  } = shortening
  const {
    landingPageUrl,
    customLandingPageUrl,
    setCustomLandingPageUrl,
    isLoadingLpUrlsFromCategories,
    isCustomLpUrlSelected,
    setLandingPageUrl,
  } = landingPages

  const { t } = useTranslation()
  const isMobile = useWindowResize()

  const [ibCodeId, setIbCodeId] = useState<IntroducingBrokerReferralTypes>(
    IntroducingBrokerReferralTypes.Default
  )

  const resolvedLandingPageUrl = getLandingPageUrl({
    isCustomLpUrlSelected,
    customLandingPageUrl,
    id: landingPageUrl?.id,
  })

  const linkStyles = getLinkStyles(isMobile)
  const hasMultipleCodes = !!ibCode && !!mtCode
  const hasSingleCode = !!ibCode || !!mtCode

  const activeReferralType = hasMultipleCodes
    ? ibCodeId
    : ibCode
    ? IntroducingBrokerReferralTypes.Default
    : IntroducingBrokerReferralTypes.MultiTier

  return (
    <Box flex direction='column' fullWidth>
      <SectionHeader
        title={t('IB.LinkHubPage.Custom target link')}
        activeTab={ibCodeId}
        setActiveTab={setIbCodeId}
        shouldRenderSegmentedControl={hasMultipleCodes}
      />
      {hasSingleCode && (
        <Box mt={hasSingleCode ? linkStyles.mt : 'x8'}>
          <ReferralCustomTargetUrl
            landingPageUrl={landingPageUrl}
            customTargetUrl={customLandingPageUrl}
            setCustomLandingPageUrl={setCustomLandingPageUrl}
            isLoadingLpUrlsFromCategories={isLoadingLpUrlsFromCategories}
            isShortLinkLoading={isShortMainLinkLoading || isShortMTLinkLoading}
            isLinkHub
            setLandingPageUrl={setLandingPageUrl}
          />
        </Box>
      )}
      <ReferralLinkUrlFields
        activeReferralType={activeReferralType}
        mainReferralLink={mainReferralLink}
        mtReferralLink={mtReferralLink}
        shortenedMainReferralLink={shortenedMainReferralLink}
        shortenedMTReferralLink={shortenedMTReferralLink}
        isShortMainLinkLoading={isShortMainLinkLoading}
        isShortMTLinkLoading={isShortMTLinkLoading}
        isShorteningAvailable={isShorteningAvailable}
        handleIBLinkShortening={handleIBLinkShortening}
        isCustomLpUrlSelected={isCustomLpUrlSelected}
        landingPageUrl={landingPageUrl}
        resolvedLandingPageUrl={resolvedLandingPageUrl}
        ibCode={ibCode}
        mtCode={mtCode}
        mtLink={mtLink}
      />
    </Box>
  )
}
